import React, { useState } from 'react';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ClientsPage } from './pages/ClientsPage';
import { ClientDetailPage } from './pages/ClientDetailPage';
import { NetworkPage } from './pages/NetworkPage';
import { DeveloperNetworkPage } from './pages/DeveloperNetworkPage';
import { BrokerageProfilePage } from './pages/BrokerageProfilePage';
import { DeveloperOfficePage } from './pages/DeveloperOfficePage';
import { RequestTicketPage } from './pages/RequestTicketPage';
import { DeveloperInfoPage } from './pages/DeveloperInfoPage';
import { DeveloperDetailsPage } from './pages/DeveloperDetailsPage';
import { InventoryPage } from './pages/InventoryPage';
import { DeveloperInventoryPage } from './pages/DeveloperInventoryPage';
import { DeveloperProjectDetailPage } from './pages/DeveloperProjectDetailPage';
import { RMIPage } from './pages/RMIPage';
import { PropertiesPage } from './pages/PropertiesPage';
import { PropertyDetailPage } from './pages/PropertyDetailPage';
import { CalendarPage } from './pages/CalendarPage';
import { ChatPage } from './pages/ChatPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { ProfilePage } from './pages/ProfilePage';
import { DesignSystemPage } from './pages/DesignSystemPage';
type UserType = 'broker' | 'developer' | null;
type CurrentPage = 'dashboard' | 'clients' | 'detail' | 'network' | 'brokerage-profile' | 'developer-office' | 'request-ticket' | 'developer-info' | 'developer-details' | 'inventory' | 'rmi' | 'properties' | 'property-detail' | 'calendar' | 'chat' | 'project-detail' | 'developer-project-detail' | 'notifications' | 'profile' | 'design-system';
export function App() {
  const [userType, setUserType] = useState<UserType>(null);
  const [userEmail, setUserEmail] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<CurrentPage>('dashboard');
  const [selectedClientId, setSelectedClientId] = useState<number | null>(null);
  const [selectedDeveloper, setSelectedDeveloper] = useState<{
    id: number;
    name: string;
    tier?: 'gold' | 'silver' | 'bronze';
  } | null>(null);
  const [selectedBrokerage, setSelectedBrokerage] = useState<{
    id: number;
    name: string;
    isInNetwork: boolean;
  } | null>(null);
  const [selectedRequestId, setSelectedRequestId] = useState<number | null>(null);
  const [selectedProjectId, setSelectedProjectId] = useState<number | null>(null);
  const [selectedPropertyId, setSelectedPropertyId] = useState<number | null>(null);
  const [projectDetailSource, setProjectDetailSource] = useState<'developer-office' | 'inventory'>('developer-office');
  const handleLogin = (type: 'broker' | 'developer', email: string) => {
    setUserType(type);
    setUserEmail(email);
    setCurrentPage('dashboard');
  };
  const handleLogout = () => {
    setUserType(null);
    setUserEmail('');
    setCurrentPage('dashboard');
  };
  // If not logged in, show login page
  if (!userType) {
    return <LoginPage onLogin={handleLogin} data-id="element-0" />;
  }
  const handleClientClick = (id: number) => {
    setSelectedClientId(id);
    setCurrentPage('detail');
    window.scrollTo(0, 0);
  };
  const handleBack = () => {
    setCurrentPage('clients');
    setSelectedClientId(null);
  };
  const handleNetworkClick = () => {
    setCurrentPage('network');
    window.scrollTo(0, 0);
  };
  const handleNetworkBack = () => {
    setCurrentPage('clients');
  };
  const handleInventoryClick = () => {
    setCurrentPage('inventory');
    window.scrollTo(0, 0);
  };
  const handleInventoryBack = () => {
    setCurrentPage('clients');
  };
  const handleInventoryProjectClick = (projectId: number, developerId: number, developerName: string) => {
    setSelectedProjectId(projectId);
    setSelectedDeveloper({
      id: developerId,
      name: developerName
    });
    setProjectDetailSource('inventory');
    setCurrentPage('project-detail');
    window.scrollTo(0, 0);
  };
  const handleRMIClick = () => {
    setCurrentPage('rmi');
    window.scrollTo(0, 0);
  };
  const handleRMIBack = () => {
    setCurrentPage('clients');
  };
  const handlePropertiesClick = () => {
    setCurrentPage('properties');
    window.scrollTo(0, 0);
  };
  const handlePropertyClick = (propertyId: number) => {
    setSelectedPropertyId(propertyId);
    setCurrentPage('property-detail');
    window.scrollTo(0, 0);
  };
  const handlePropertyDetailBack = () => {
    setCurrentPage('properties');
    setSelectedPropertyId(null);
  };
  const handleClientsClick = () => {
    setCurrentPage('clients');
    window.scrollTo(0, 0);
  };
  const handleDashboardClick = () => {
    setCurrentPage('dashboard');
    window.scrollTo(0, 0);
  };
  const handleDeveloperOfficeClick = (developerId: number, developerName: string, tier?: 'gold' | 'silver' | 'bronze') => {
    setSelectedDeveloper({
      id: developerId,
      name: developerName,
      tier
    });
    setCurrentPage('developer-office');
    window.scrollTo(0, 0);
  };
  const handleDeveloperOfficeBack = () => {
    setCurrentPage('network');
    setSelectedDeveloper(null);
  };
  const handleRequestClick = (requestId: number) => {
    setSelectedRequestId(requestId);
    setCurrentPage('request-ticket');
    window.scrollTo(0, 0);
  };
  const handleRequestTicketBack = () => {
    // Check if we came from RMI page or developer office
    if (selectedDeveloper) {
      setCurrentPage('developer-office');
    } else {
      setCurrentPage('rmi');
    }
    setSelectedRequestId(null);
  };
  const handleDeveloperInfoClick = (developerId: number, developerName: string) => {
    setSelectedDeveloper({
      id: developerId,
      name: developerName
    });
    setCurrentPage('developer-info');
    window.scrollTo(0, 0);
  };
  const handleDeveloperInfoClose = () => {
    setCurrentPage('network');
    setSelectedDeveloper(null);
  };
  const handleGetAccreditedClick = () => {
    if (selectedDeveloper) {
      setCurrentPage('developer-details');
      window.scrollTo(0, 0);
    }
  };
  const handleDeveloperDetailsBack = () => {
    setCurrentPage('developer-info');
  };
  const handleAccreditationSubmit = () => {
    // Handle accreditation submission
    alert('Accreditation request submitted successfully!');
    setCurrentPage('network');
    setSelectedDeveloper(null);
  };
  const handleCalendarClick = () => {
    setCurrentPage('calendar');
    window.scrollTo(0, 0);
  };
  const handleCalendarBack = () => {
    setCurrentPage('clients');
  };
  const handleChatClick = () => {
    setCurrentPage('chat');
    window.scrollTo(0, 0);
  };
  const handleChatBack = () => {
    setCurrentPage('clients');
  };
  const handleProjectClick = (projectId: number) => {
    setSelectedProjectId(projectId);
    // If developer, go to developer project detail page
    if (userType === 'developer') {
      setCurrentPage('developer-project-detail');
    } else {
      // If broker, go to regular project detail page
      setProjectDetailSource('developer-office');
      setCurrentPage('project-detail');
    }
    window.scrollTo(0, 0);
  };
  const handleDeveloperProjectDetailBack = () => {
    setCurrentPage('inventory');
    setSelectedProjectId(null);
  };
  const handleProjectDetailBack = () => {
    if (projectDetailSource === 'inventory') {
      setCurrentPage('inventory');
      setSelectedDeveloper(null);
    } else {
      setCurrentPage('developer-office');
    }
    setSelectedProjectId(null);
  };
  const handleProjectDetailBackFromInventory = () => {
    setCurrentPage('inventory');
    setSelectedProjectId(null);
    setSelectedDeveloper(null);
  };
  const handleNotificationsClick = () => {
    setCurrentPage('notifications');
    window.scrollTo(0, 0);
  };
  const handleNotificationsBack = () => {
    setCurrentPage('dashboard');
  };
  const handleProfileClick = () => {
    setCurrentPage('profile');
    window.scrollTo(0, 0);
  };
  const handleProfileBack = () => {
    setCurrentPage('dashboard');
  };
  const handleBrokerageProfileClick = (brokerId: number, brokerName: string, isInNetwork: boolean = false) => {
    setSelectedBrokerage({
      id: brokerId,
      name: brokerName,
      isInNetwork
    });
    setCurrentPage('brokerage-profile');
    window.scrollTo(0, 0);
  };
  const handleBrokerageProfileBack = () => {
    setCurrentPage('network');
    setSelectedBrokerage(null);
  };
  const handleAddBrokerageToNetwork = () => {
    alert('Brokerage added to your network!');
    if (selectedBrokerage) {
      setSelectedBrokerage({
        ...selectedBrokerage,
        isInNetwork: true
      });
    }
  };
  const handleBrokerageRMIClick = (rmiId: number) => {
    setSelectedRequestId(rmiId);
    setCurrentPage('request-ticket');
    window.scrollTo(0, 0);
  };
  const handleDesignSystemClick = () => {
    setCurrentPage('design-system');
    window.scrollTo(0, 0);
  };
  const handleDesignSystemBack = () => {
    setCurrentPage('profile');
  };
  return <div className="bg-neutral-bg min-h-screen w-full overflow-x-hidden" data-id="element-1">
      {currentPage === 'dashboard' && <DashboardPage onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onPropertiesClick={handlePropertiesClick} onClientsClick={handleClientsClick} onCalendarClick={handleCalendarClick} onChatClick={handleChatClick} onNotificationsClick={handleNotificationsClick} onProfileClick={handleProfileClick} data-id="element-2" />}
      {currentPage === 'notifications' && <NotificationsPage onBack={handleNotificationsBack} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onCalendarClick={handleCalendarClick} onChatClick={handleChatClick} onProfileClick={handleProfileClick} data-id="element-3" />}
      {currentPage === 'profile' && <ProfilePage onBack={handleProfileBack} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onNotificationsClick={handleNotificationsClick} onLogout={handleLogout} onDesignSystemClick={handleDesignSystemClick} data-id="element-4" />}
      {currentPage === 'design-system' && <DesignSystemPage onBack={handleDesignSystemBack} data-id="element-5" />}
      {currentPage === 'clients' && <ClientsPage onClientClick={handleClientClick} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onPropertiesClick={handlePropertiesClick} onCalendarClick={handleCalendarClick} onChatClick={handleChatClick} onDashboardClick={handleDashboardClick} onNotificationsClick={handleNotificationsClick} onProfileClick={handleProfileClick} data-id="element-6" />}
      {currentPage === 'properties' && <PropertiesPage onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onClientsClick={handleClientsClick} onDashboardClick={handleDashboardClick} onProfileClick={handleProfileClick} onPropertyClick={handlePropertyClick} data-id="element-7" />}
      {currentPage === 'property-detail' && selectedPropertyId && <PropertyDetailPage propertyId={selectedPropertyId} onBack={handlePropertyDetailBack} data-id="element-8" />}
      {currentPage === 'detail' && <ClientDetailPage clientId={selectedClientId || 1} onBack={handleBack} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onProfileClick={handleProfileClick} data-id="element-9" />}
      {currentPage === 'network' && userType === 'broker' && <NetworkPage onBack={handleNetworkBack} onDeveloperOfficeClick={handleDeveloperOfficeClick} onDeveloperInfoClick={handleDeveloperInfoClick} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onProfileClick={handleProfileClick} data-id="element-10" />}
      {currentPage === 'network' && userType === 'developer' && <DeveloperNetworkPage onBack={handleNetworkBack} onBrokerageProfileClick={(id, name, isInNetwork) => {
      // Pass the isInNetwork flag directly from DeveloperNetworkPage
      handleBrokerageProfileClick(id, name, isInNetwork);
    }} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onProfileClick={handleProfileClick} data-id="element-11" />}
      {currentPage === 'brokerage-profile' && selectedBrokerage && <BrokerageProfilePage brokerageId={selectedBrokerage.id} brokerageName={selectedBrokerage.name} isInNetwork={selectedBrokerage.isInNetwork} onBack={handleBrokerageProfileBack} onAddToNetwork={handleAddBrokerageToNetwork} onRMIClick={handleBrokerageRMIClick} data-id="element-12" />}
      {currentPage === 'inventory' && userType === 'broker' && <InventoryPage onBack={handleInventoryBack} onNetworkClick={handleNetworkClick} onRMIClick={handleRMIClick} onInventoryClick={handleInventoryClick} onProjectClick={handleInventoryProjectClick} onProfileClick={handleProfileClick} data-id="element-13" />}
      {currentPage === 'inventory' && userType === 'developer' && <DeveloperInventoryPage onBack={handleInventoryBack} onNetworkClick={handleNetworkClick} onRMIClick={handleRMIClick} onInventoryClick={handleInventoryClick} onProjectClick={handleProjectClick} onProfileClick={handleProfileClick} data-id="element-14" />}
      {currentPage === 'rmi' && <RMIPage onBack={handleRMIBack} onRequestClick={handleRequestClick} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onProfileClick={handleProfileClick} data-id="element-15" />}
      {currentPage === 'developer-office' && selectedDeveloper && <DeveloperOfficePage developerId={selectedDeveloper.id} developerName={selectedDeveloper.name} tier={selectedDeveloper.tier} onBack={handleDeveloperOfficeBack} onRequestClick={handleRequestClick} onProjectClick={handleProjectClick} onProfileClick={handleProfileClick} data-id="element-16" />}
      {currentPage === 'request-ticket' && selectedRequestId && <RequestTicketPage requestId={selectedRequestId} onBack={handleRequestTicketBack} data-id="element-17" />}
      {currentPage === 'developer-info' && selectedDeveloper && <DeveloperInfoPage developerId={selectedDeveloper.id} developerName={selectedDeveloper.name} onClose={handleDeveloperInfoClose} onGetAccredited={handleGetAccreditedClick} data-id="element-18" />}
      {currentPage === 'developer-details' && selectedDeveloper && <DeveloperDetailsPage developerId={selectedDeveloper.id} developerName={selectedDeveloper.name} onBack={handleDeveloperDetailsBack} onAccreditationSubmit={handleAccreditationSubmit} showAccreditationModal={true} data-id="element-19" />}
      {currentPage === 'calendar' && <CalendarPage onBack={handleCalendarBack} onClientClick={handleClientClick} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onProfileClick={handleProfileClick} data-id="element-20" />}
      {currentPage === 'chat' && <ChatPage onBack={handleChatBack} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onProfileClick={handleProfileClick} data-id="element-21" />}
      {currentPage === 'project-detail' && selectedDeveloper && selectedProjectId && <ProjectDetailPage projectId={selectedProjectId} developerId={selectedDeveloper.id} developerName={selectedDeveloper.name} developerTier={selectedDeveloper.tier} onBack={handleProjectDetailBack} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onProfileClick={handleProfileClick} data-id="element-22" />}
      {currentPage === 'developer-project-detail' && selectedProjectId && userType === 'developer' && <DeveloperProjectDetailPage projectId={selectedProjectId} onBack={handleDeveloperProjectDetailBack} data-id="element-23" />}
    </div>;
}